export function encodeStepToUrl(step: string): string {
  const stepParam = encodeURIComponent(step);
  return `?step=${stepParam}`;
}

export function decodeStepFromUrl(search: string): { step: string } {
  const params = new URLSearchParams(search);
  const step = params.get("step") || "select";
  return { step };
}
